import { SortParams } from '../typings/grid';
import {
    NewProduct,
    Product,
    ProductsForm,
    ProductsListCellItem,
    ProductsPageStates
} from '../typings/products';

export const FETCH_INTERNAL_PRODUCTS_DATA = 'FETCH_INTERNAL_PRODUCTS_DATA';
export type FETCH_INTERNAL_PRODUCTS_DATA = typeof FETCH_INTERNAL_PRODUCTS_DATA;

export const UPDATE_INTERNAL_PRODUCTS_DATA = 'UPDATE_INTERNAL_PRODUCTS_DATA';
export type UPDATE_INTERNAL_PRODUCTS_DATA = typeof UPDATE_INTERNAL_PRODUCTS_DATA;

export const SORT_INTERNAL_PRODUCTS = 'SORT_INTERNAL_PRODUCTS';
export type SORT_INTERNAL_PRODUCTS = typeof SORT_INTERNAL_PRODUCTS;

export const SET_PRODUCTS_PAGE_STATUS = 'SET_PRODUCTS_PAGE_STATUS';
export type SET_PRODUCTS_PAGE_STATUS = typeof SET_PRODUCTS_PAGE_STATUS;

export const FETCH_ADD_INTERNAL_PRODUCT = 'FETCH_ADD_INTERNAL_PRODUCT';
export type FETCH_ADD_INTERNAL_PRODUCT = typeof FETCH_ADD_INTERNAL_PRODUCT;

export const CHANGE_INTERNAL_PRODUCTS_FORM = 'CHANGE_INTERNAL_PRODUCTS_FORM';
export type CHANGE_INTERNAL_PRODUCTS_FORM = typeof CHANGE_INTERNAL_PRODUCTS_FORM;

export const FETCH_CHANGE_INTERNAL_PRODUCT = 'FETCH_CHANGE_INTERNAL_PRODUCT';
export type FETCH_CHANGE_INTERNAL_PRODUCT = typeof FETCH_CHANGE_INTERNAL_PRODUCT;

export const ADD_INTERNAL_PRODUCT = 'ADD_INTERNAL_PRODUCT';
export type ADD_INTERNAL_PRODUCT = typeof ADD_INTERNAL_PRODUCT;

export const UPDATE_INTERNAL_PRODUCT = 'UPDATE_INTERNAL_PRODUCT';
export type UPDATE_INTERNAL_PRODUCT = typeof UPDATE_INTERNAL_PRODUCT;

export const CHANGE_INTERNAL_PRODUCT_CELL = 'CHANGE_INTERNAL_PRODUCT_CELL';
export type CHANGE_INTERNAL_PRODUCT_CELL = typeof CHANGE_INTERNAL_PRODUCT_CELL;

export const SEARCH_INTERNAL_PRODUCTS = 'SEARCH_INTERNAL_PRODUCTS';
export type SEARCH_INTERNAL_PRODUCTS = typeof SEARCH_INTERNAL_PRODUCTS;

export interface FetchProductsDataAction {
    type: FETCH_INTERNAL_PRODUCTS_DATA;
}

export interface UpdateProductsDataAction {
    type: UPDATE_INTERNAL_PRODUCTS_DATA;
    products: Product[];
    sortParams?: SortParams;
}

export interface SortProductsAction {
    type: SORT_INTERNAL_PRODUCTS;
    sortParams: SortParams;
}

export interface SetProductsPageStatusAction {
    type: SET_PRODUCTS_PAGE_STATUS;
    status: ProductsPageStates;
}

export interface FetchAddProductAction {
    type: FETCH_ADD_INTERNAL_PRODUCT;
    product: NewProduct;
}

export interface FetchChangeProductAction {
    type: FETCH_CHANGE_INTERNAL_PRODUCT;
    product: Product;
}

export interface ChangeProductsFormAction {
    type: CHANGE_INTERNAL_PRODUCTS_FORM;
    form: ProductsForm;
}

export interface AddProductAction {
    type: ADD_INTERNAL_PRODUCT;
    product: Product;
    sortParams?: SortParams;
}

export interface UpdateProductAction {
    type: UPDATE_INTERNAL_PRODUCT;
    product: Product;
}

export interface ChangeProductCellAction {
    type: CHANGE_INTERNAL_PRODUCT_CELL;
    product: ProductsListCellItem;
}

interface SearchInternalProductsAction {
    type: SEARCH_INTERNAL_PRODUCTS;
    searchInput: string;
}

export function fetchProductsData(): FetchProductsDataAction {
    return {
        type: FETCH_INTERNAL_PRODUCTS_DATA
    };
}

export function updateProductsData(
    products: Product[],
    sortParams?: SortParams
): UpdateProductsDataAction {
    return {
        type: UPDATE_INTERNAL_PRODUCTS_DATA,
        products,
        sortParams
    };
}

export function sortProducts(sortParams: SortParams): SortProductsAction {
    return {
        type: SORT_INTERNAL_PRODUCTS,
        sortParams
    };
}

export function setProductsPageStatus(
    status: ProductsPageStates
): SetProductsPageStatusAction {
    return {
        type: SET_PRODUCTS_PAGE_STATUS,
        status
    };
}

export function fetchAddProduct(product: NewProduct): FetchAddProductAction {
    return {
        type: FETCH_ADD_INTERNAL_PRODUCT,
        product
    };
}

export function fetchChangeProduct(
    product: ProductsListCellItem
): FetchChangeProductAction {
    const { isEdited, newDescription, ...productProps } = product;

    return {
        type: FETCH_CHANGE_INTERNAL_PRODUCT,
        product: {
            ...productProps,
            description: newDescription
        }
    };
}

export function changeProductsForm(
    form: ProductsForm
): ChangeProductsFormAction {
    return {
        type: CHANGE_INTERNAL_PRODUCTS_FORM,
        form
    };
}

export function addProduct(
    product: Product,
    sortParams?: SortParams
): AddProductAction {
    return {
        type: ADD_INTERNAL_PRODUCT,
        product,
        sortParams
    };
}

export function updateProduct(product: Product): UpdateProductAction {
    return {
        type: UPDATE_INTERNAL_PRODUCT,
        product
    };
}

export function changeProductCell(
    product: ProductsListCellItem
): ChangeProductCellAction {
    return {
        type: CHANGE_INTERNAL_PRODUCT_CELL,
        product
    };
}

export function searchInternalProducts(
    searchInput: string
): SearchInternalProductsAction {
    return {
        type: SEARCH_INTERNAL_PRODUCTS,
        searchInput
    };
}

export type ProductsAction =
    | FetchProductsDataAction
    | UpdateProductsDataAction
    | SortProductsAction
    | SetProductsPageStatusAction
    | FetchAddProductAction
    | FetchChangeProductAction
    | ChangeProductsFormAction
    | ChangeProductCellAction
    | AddProductAction
    | UpdateProductAction
    | SearchInternalProductsAction;
